import React, { useState } from "react";
import CustomSelect from "../../controls/CustomSelect";
import useTitanApp from "../../../hooks/useTitanApp";

export default function SendToPharmacy({
  setSendToPharmacyID,
  setPharmacyError,
  setSendToPharmacy,
  isDisabled,
  setButtonsDisabled,
}) {
  const { appState } = useTitanApp();
  const { pharmacies } = appState;

  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const pharmaciesOptions =
    pharmacies?.map((pharmacy) => pharmacy.teamPharmacyName) || [];

  const handlePharmacyChange = (selectedName) => {
    setButtonsDisabled(false);
    setSelectedPharmacy(selectedName);
    const selectedPharmacyObj = pharmacies?.find(
      (pharmacy) => pharmacy.teamPharmacyName === selectedName
    );

    setSendToPharmacyID(selectedPharmacyObj?.teamPharmacyID);
    setSendToPharmacy(selectedPharmacyObj);
    const pharmacyID = selectedPharmacyObj?.teamPharmacyID;

    if (pharmacyID) {
      setPharmacyError("");
    }
  };

  return (
    <div className="send-to-pharmacy-wrapper">
      <CustomSelect
        label="Choose which pharmacy to send the prescription to:"
        isDisabled={isDisabled}
        value={selectedPharmacy}
        options={pharmaciesOptions}
        onChange={handlePharmacyChange}
      />
    </div>
  );
}
